import { render, staticRenderFns } from "./ChangeCompanyName.vue?vue&type=template&id=528a31a2&scoped=true"
import script from "./ChangeCompanyName.vue?vue&type=script&lang=js"
export * from "./ChangeCompanyName.vue?vue&type=script&lang=js"
import style0 from "./ChangeCompanyName.vue?vue&type=style&index=0&id=528a31a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528a31a2",
  null
  
)

export default component.exports